import { Center, Spinner, SpinnerProps } from '@chakra-ui/react'
import React, { FC } from 'react'

export const FullBlockSpinner: FC<SpinnerProps & { dataTest?: string }> = ({
  dataTest = 'Spinner',
  ...props
}) => (
  <Center
    pos="absolute"
    h="100%"
    w="100%"
    top="0"
    left="0"
    bgColor="rgba(255, 255, 255, 0.5)"
  >
    <Spinner data-test={dataTest} {...props} />
  </Center>
)
